import { Box, Checkbox, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

let desc = '';

class Subrogacion extends Component {
    constructor(props){
        super(props);
        this.state = {
            busqueda: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                escalafon: '',
                grado: '',
                cargaHorariaHora: '',
                cargaHorariaMinutos: '0',
                desde: '',
                hasta: '',
            },

            checkedList: {
                todasSub: true,
                activas: false,
                finalizadas: false,
            },

            datoModal: {
                idSubrogacion: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                escalafonSubrogacion: '',
                gradoSubrogacion: '',
                cargaHorariaHoraSubrogacion: '',
                cargaHorariaMinutosSubrogacion: '0',
                desdeSubrogacion: '',
                hastaSubrogacion: '',
                activa: '',
            },

            errores: null,
            notificaciones: null,
            consulta: false,
            finalizar: false,
            borrar: false,
            numeroNombre: [],
            escalafones: [],
            datosConsulta: [],
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.enviarConsulta = this.enviarConsulta.bind(this);
        this.enviarSubrogacion = this.enviarSubrogacion.bind(this);
        this.cambioListado = this.cambioListado.bind(this);
        this.manejarFinalizar = this.manejarFinalizar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarCambiosDatosModal = this.manejarCambiosDatosModal.bind(this);
        this.enviarModal = this.enviarModal.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.enviarModalBorrar = this.enviarModalBorrar.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
    }


    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });
    }

    render(){
        return (
            <>
                {sessionStorage.login && sessionStorage.tipoUsuario === '4'
                ?
                    <Container>
                        <h3>Subrogación</h3>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        <br/>
                        <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.5}>
                                        <Item>Número Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambiosDatos}/></Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                    <button className="btn btn-outline-primary mx-2" type='button' onClick={this.enviarConsulta}>Buscar</button>
                                    </Grid>
                                </Grid>
                        </Box>
                        {this.state.consulta
                        ?
                            <Container>
                                <br/>
                                <FormControlLabel label='Todas las Subrogaciones' control={<Checkbox checked={this.state.checkedList.todasSub} onChange={this.cambioListado} id='todasSub' inputProps={{ 'aria-label': 'controlled' }} /> }/>
                                <FormControlLabel label='Subrogaciones Activas' control={<Checkbox checked={this.state.checkedList.activas} onChange={this.cambioListado} id='activas' inputProps={{ 'aria-label': 'controlled' }} /> }/>
                                <FormControlLabel label='Subrogaciones Finalizadas' control={<Checkbox checked={this.state.checkedList.finalizadas} onChange={this.cambioListado} id='finalizadas'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Número</StyledTableCell>
                                                <StyledTableCell>Nombre</StyledTableCell>
                                                <StyledTableCell>Escalafon</StyledTableCell>
                                                <StyledTableCell>Grado</StyledTableCell>
                                                <StyledTableCell>Carga Horaria(Horas)</StyledTableCell>
                                                <StyledTableCell>Carga Horaria(Minutos)</StyledTableCell>
                                                <StyledTableCell>Desde</StyledTableCell>
                                                {this.state.checkedList.finalizadas ? <StyledTableCell>Hasta</StyledTableCell> : <StyledTableCell></StyledTableCell> }
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.datosConsulta.map((name2) => (
                                                <StyledTableRow key={name2.idSubrogacion}>
                                                    {this.state.escalafones.map((name) => {
                                                        if(name.idEscalafon === name2.escalafonSubrogacion){
                                                            desc = name.descripcion;
                                                        }
                                                    })}
                                                    <StyledTableCell>{name2.numeroFuncionario}</StyledTableCell>
                                                    <StyledTableCell>{name2.nombreFuncionario}</StyledTableCell>
                                                    <StyledTableCell>{desc}</StyledTableCell>
                                                    <StyledTableCell>{name2.gradoSubrogacion}</StyledTableCell>
                                                    <StyledTableCell>{name2.cargaHorariaHoraSubrogacion}</StyledTableCell>
                                                    <StyledTableCell>{name2.cargaHorariaMinutosSubrogacion}</StyledTableCell>
                                                    <StyledTableCell>{name2.desdeSubrogacion.substring(8,10) + '/' + name2.desdeSubrogacion.substring(5,7) + '/' + name2.desdeSubrogacion.substring(0,4)}</StyledTableCell>
                                                    {name2.activa === 1 ? <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarFinalizar(name2)}>Finalizar</button></StyledTableCell> : this.state.checkedList.finalizadas ? <StyledTableCell>{name2.hastaSubrogacion.substring(8,10) + '/' + name2.hastaSubrogacion.substring(5,7) + '/' + name2.hastaSubrogacion.substring(0,4)}</StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                                    {name2.activa === 1 ? <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarBorrar(name2)}>Borrar</button></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <br/>
                                <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarAtras}>Volver</button>
                                {/*Modal para finalizar la subrogacion*/}
                                <Modal open={this.state.finalizar}>
                                    <form className='formulario1'>
                                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                        <Box sx={styleModal} >
                                            <h3 style={{textAlign:'center'}}>Finalizar Subrogación</h3>
                                            <Grid container spacing={2} rowSpacing={1}>
                                                <Grid item xs={5}>
                                                    <Item>Fecha Finalización</Item>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='hastaSubrogacion' value={this.state.datoModal.hastaSubrogacion} onChange={this.manejarCambiosDatosModal} type="date" /></Item>
                                                </Grid>
                                                <Grid item xs={2}>

                                                </Grid>
                                                <Grid item xs={3}>

                                                </Grid>
                                                <Grid item xs={3}>
                                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.enviarModal}>Enviar</button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </form>
                                </Modal>

                                {/*Modal para eliminar la subrogacion*/}
                                <Modal open={this.state.borrar}>
                                    <form className='formulario1'>
                                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                        <Box sx={styleModal} >
                                            <h3 style={{textAlign:'center'}}>Eliminar Subrogación</h3>
                                            <Grid container spacing={2} rowSpacing={1}>
                                                <Grid item xs={3.5}>

                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Item>¿Eliminar Subrogación?</Item>
                                                </Grid>
                                                <Grid item xs={3.5}>

                                                </Grid>
                                                <Grid item xs={3}>
                                                    
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.enviarModalBorrar}>Confirmar</button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </form>
                                </Modal>
                            </Container>
                        :
                            <Container>
                                <br/>
                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Número</StyledTableCell>
                                                <StyledTableCell>Nombre</StyledTableCell>
                                                <StyledTableCell>Escalafon</StyledTableCell>
                                                <StyledTableCell>Grado</StyledTableCell>
                                                <StyledTableCell>Carga Horaria(Horas)</StyledTableCell>
                                                <StyledTableCell>Carga Horaria(Minutos)</StyledTableCell>
                                                <StyledTableCell>Desde</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <StyledTableRow>
                                                <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell>{this.state.busqueda.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.busqueda.escalafon} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>ESCALAFON</option>
                                                        {this.state.escalafones.map((name) =>
                                                            <option
                                                            key={name.idEscalafon}
                                                            value={name.idEscalafon}
                                                            >{name.descripcion}</option>
                                                            )}
                                                    </select>
                                                </StyledTableCell>
                                                <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='grado' value={this.state.busqueda.grado} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='cargaHorariaHora' value={this.state.busqueda.cargaHorariaHora} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='cargaHorariaMinutos' value={this.state.busqueda.cargaHorariaMinutos} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                                <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='desde' value={this.state.busqueda.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            </StyledTableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <br/>
                                <button className="btn btn-outline-primary mx-2" type='button' onClick={this.enviarSubrogacion}>Guardar</button>
                            </Container>
                        }
                    </Container>
                :
                    null
                }
            </>
        )//Return
    }//Render

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            finalizar: false,
            borrar: false,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            if((clave === 'numeroFuncionario') && (valor !== '') ){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'nombreFuncionario') && (valor === '')){
                numFunActualizado['nombreFuncionario'] = '';
            }


            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async enviarConsulta(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.busqueda]);

        const res = await fetch(`${Constantes.RUTA_API}/obtener_subrogaciones.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await res.json()
        if(exito){
            this.setState({
                errores: null,
                notificaciones: null,
                consulta: true,
                datosConsulta: exito,
                finalizar: false,
                borrar: false,
            })
        }
    }

    async enviarSubrogacion(e){
        e.preventDefault();
        if(this.state.busqueda.numeroFuncionario === ''){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR UN NUMERO DE FUNCIONARIO',
            });
        }else if((this.state.busqueda.numeroFuncionario !== '') && (this.state.busqueda.nombreFuncionario === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR UN NUMERO DE FUNCIONARIO VALIDO',
            });
        }else if((this.state.busqueda.escalafon === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR UN ESCALAFON',
            });
        }else if((this.state.busqueda.grado === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR UN GRADO',
            });
        }else if((this.state.busqueda.cargaHorariaHora === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR LA CARGA HORARIA (HORAS)',
            });
        }else if((this.state.busqueda.cargaHorariaMinutos === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR LA CARGA HORARIA (MINUTOS)',
            });
        }else if((this.state.busqueda.desde === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR LA FECHA DESDE',
            });
        }else{
            const cargaUtil = JSON.stringify([this.state.busqueda]);

            const res = await fetch(`${Constantes.RUTA_API}/guardar_subrogacion.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            if(exito){
                this.setState({
                    errores: null,
                    notificaciones: 'LOS DATOS FUERON INGRESADOS CORRECTAMENTE',
                    busqueda: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        escalafon: '',
                        grado: '',
                        cargaHorariaHora: '',
                        cargaHorariaMinutos: '0',
                        desde: '',
                        hasta: '',
                    },
                    datosConsulta: [],
                    finalizar: false,
                    borrar: false,
                })
            }
        }
    }

    async cambioListado(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });

        if(clave === 'todasSub'){

            const cargaUtil = JSON.stringify([this.state.busqueda]);

            const res = await fetch(`${Constantes.RUTA_API}/obtener_subrogaciones.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            if(exito){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    consulta: true,
                    datosConsulta: exito,
                    finalizar: false,
                    borrar: false,
                })
            }

            if(valor){
                this.setState({
                    checkedList: {
                        todasSub: true,
                        activas: false,
                        finalizadas: false,
                    },
                });
            }
        }else if(clave === 'activas'){
            

            const cargaUtil = JSON.stringify([this.state.busqueda]);

            const res = await fetch(`${Constantes.RUTA_API}/obtener_subrogacionesActivas.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            if(exito){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    consulta: true,
                    datosConsulta: exito,
                    finalizar: false,
                    borrar: false,
                })
            }

            if(valor){
                this.setState({
                    checkedList: {
                        todasSub: false,
                        activas: true,
                        finalizadas: false,
                    },
                });
            }
        }else if(clave === 'finalizadas'){


            const cargaUtil = JSON.stringify([this.state.busqueda]);

            const res = await fetch(`${Constantes.RUTA_API}/obtener_subrogacionesFinalizadas.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            if(exito){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    consulta: true,
                    datosConsulta: exito,
                    finalizar: false,
                    borrar: false,
                })
            }

            if(valor){
                this.setState({
                    checkedList: {
                        todasSub: false,
                        activas: false,
                        finalizadas: true,
                    },
                });
            }
        }
    }

    manejarFinalizar(dato){
        this.setState({
            finalizar: true,
            borrar: false,
            datoModal: dato,
        });

        this.setState(state => {
            const datoMovAct = state.datoModal;
            datoMovAct['hastaSubrogacion'] = '';
            return {
                datoModal: datoMovAct,
            }
        });
    }
    
    cerrarModal(e){
        this.setState({
            finalizar: false,
            borrar: false,
            errores: null,
            notificaciones: null,
        });
    }

    manejarCambiosDatosModal(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        })

        this.setState(state => {
            const numFunActualizado = state.datoModal;
            numFunActualizado[clave] = valor;

            return{
                datoModal: numFunActualizado,
            };
        });
    }

    async enviarModal(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.datoModal, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/editar_subrogacion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito){
            this.setState({
                errores: null,
                notificaciones: 'DATOS INGRESADOS CON EXITO!',
                datoModal: {
                    idSubrogacion: '',
                    numeroFuncionario: '',
                    nombreFuncionario: '',
                    escalafonSubrogacion: '',
                    gradoSubrogacion: '',
                    cargaHorariaHoraSubrogacion: '',
                    cargaHorariaMinutosSubrogacion: '0',
                    desdeSubrogacion: '',
                    hastaSubrogacion: '',
                    activa: '',
                },
                finalizar: false,
                borrar: false,
                datosConsulta: [],
                consulta: false,
                busqueda: {
                    numeroFuncionario: '',
                    nombreFuncionario: '',
                    escalafon: '',
                    grado: '',
                    cargaHorariaHora: '',
                    cargaHorariaMinutos: '0',
                    desde: '',
                    hasta: '',
                },
            });
        }
    }

    manejarBorrar(dato){
        this.setState({
            finalizar: false,
            borrar: true,
            datoModal: dato,
        });

        this.setState(state => {
            const datoMovAct = state.datoModal;
            datoMovAct['hastaSubrogacion'] = '';
            return {
                datoModal: datoMovAct,
            }
        });
    }

    async enviarModalBorrar(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.datoModal, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_subrogacion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito){
            this.setState({
                errores: null,
                notificaciones: 'DATOS BORRADOS CON EXITO!',
                datoModal: {
                    idSubrogacion: '',
                    numeroFuncionario: '',
                    nombreFuncionario: '',
                    escalafonSubrogacion: '',
                    gradoSubrogacion: '',
                    cargaHorariaHoraSubrogacion: '',
                    cargaHorariaMinutosSubrogacion: '0',
                    desdeSubrogacion: '',
                    hastaSubrogacion: '',
                    activa: '',
                },
                finalizar: false,
                borrar: false,
                datosConsulta: [],
                consulta: false,
                busqueda: {
                    numeroFuncionario: '',
                    nombreFuncionario: '',
                    escalafon: '',
                    grado: '',
                    cargaHorariaHora: '',
                    cargaHorariaMinutos: '0',
                    desde: '',
                    hasta: '',
                },
            });
        }
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            busqueda: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                escalafon: '',
                grado: '',
                cargaHorariaHora: '',
                cargaHorariaMinutos: '0',
                desde: '',
                hasta: '',
            },

            checkedList: {
                todasSub: true,
                activas: false,
                finalizadas: false,
            },

            datoModal: {
                idSubrogacion: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                escalafonSubrogacion: '',
                gradoSubrogacion: '',
                cargaHorariaHoraSubrogacion: '',
                cargaHorariaMinutosSubrogacion: '0',
                desdeSubrogacion: '',
                hastaSubrogacion: '',
                activa: '',
            },

            errores: null,
            notificaciones: null,
            consulta: false,
            finalizar: false,
            borrar: false,
            datosConsulta: [],
        });
    }
}

export default Subrogacion